export enum SPARE_PART_CATALOG_DOMAIN {
  LIST = 'list',
  BY_SUPPLIER_ID = 'bySupplierId',
}

export const SPARE_PART_CATALOG_DOMAIN_KEY = 'sparePartCatalog';
